<template>
	<JBox>
		<!-- Info -->
		<JBox class="s-bg-white s-shadow s-overflow-hidden sm:s-rounded-lg">
			<JBox class="s-px-4 s-py-5 s-border-b s-border-gray-200 sm:s-px-6">
				<JHeadline class="s-text-xl">
					{{ app.appName || "..." }}
				</JHeadline>
			</JBox>

			<!-- Info -->
			<JBox class="s-px-4 s-py-5 sm:s-p-0">
				<dl class="">
					<JBox class="sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-px-6 sm:s-py-5">
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							Name
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ app.appName }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							App ID
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ app.appId }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							URL
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ app && app.urlRouting && app.urlRouting.regexPattern }}
						</dd>
					</JBox>

					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							Account invitation email from
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ app.email }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							Account invitation email name
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ app.emailSenderName }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">Created</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							<JText>{{ app.formattedCreatedAt }}</JText>
							<JText class="s-text-gray-500">{{ app.createdBy && app.createdBy.username }}</JText>
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">Updated</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							<JText>{{ app.formattedLastModifiedAt }}</JText>
							<JText class="s-text-gray-500">{{ app.lastModifiedBy && app.lastModifiedBy.username }}</JText>
						</dd>
					</JBox>

					<!-- <JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">Last Release</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							20/12/2019
							<JText class="s-mt-2 s-text-yellow-400">
								Product has been changed but the latest changes are not released in the appion environment yet.
							</JText>
						</dd>
					</JBox> -->
				</dl>
			</JBox>
		</JBox>

		<!-- Update Modal -->
		<Portal to="layer0">
			<CModal :isVisible="showUpdateApp">
				<JBox class="s-p-8">
					<AppUpdate @cancel="showUpdateApp = false" @updated="showUpdateApp = false" />
				</JBox>
			</CModal>
		</Portal>

		<!-- Confirm Delete Modal -->
		<Portal to="layer1">
			<CModal :isVisible="showDeleteApp" variant="default-small">
				<JBox class="s-p-8">
					<JText class="s-text-lg s-text-gray-600 s-text-center">
						Do you really want to delete this app? This action can't be reverted.
					</JText>
					<JSpinner type="dots" class="s-mt-4" v-if="isDeleteLoading" />
					<JFlex class="s-justify-center s-mt-10">
						<JButton variant="error" class="s-mr-4" @click="handleDelete(app.appId)">Delete</JButton>
						<JButton variant="white" @click="showDeleteApp = false">Cancel</JButton>
					</JFlex>
				</JBox>
			</CModal>
		</Portal>
	</JBox>
</template>

<script>
import AppUpdate from "./AppUpdate"

export default {
	components: { AppUpdate },
	data() {
		return {
			showUpdateApp: false,
			showDeleteApp: false,

			isDeleteLoading: false,
			deleteError: ""
		}
	},

	computed: {
		app() {
			return this.$store.state?.apps?.detail ?? {}
		}
	},

	methods: {
		async handleDelete(appId) {
			if (!appId) return
			if (this.isDeleteLoading) return // prevent double submit
			this.deleteError = "" // reset

			this.isDeleteLoading = true
			const { isSuccess, res } = await this.$store.dispatch("apps/deleteApp", { appId })
			this.isDeleteLoading = false

			// Handle error
			if (!isSuccess) {
				this.deleteError = res?.data?.deleteApp?.errors?.[0] ?? "Oops, there was a problem, please try again later"
				return
			}

			this.$router.push({ name: "ViewAppsHome" })
		}
	}
}
</script>
